import { useNavigate } from 'react-router-dom'
import ChapterChart from './ChapterChart'

export default function ExampleChart() {
  const navigate = useNavigate()

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      {/* Nav bar — hidden when printing */}
      <nav className="no-print" style={styles.nav}>
        <button style={styles.backBtn} onClick={() => navigate('/')}>
          ← Dashboard
        </button>
        <span style={styles.navTitle}>Example Chart — Romans 1</span>
        <button style={styles.printBtn} onClick={() => window.print()}>
          🖨 Print
        </button>
      </nav>

      {/* Chart */}
      <ChapterChart />
    </div>
  )
}

const styles: Record<string, React.CSSProperties> = {
  nav: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 24px',
    background: '#1e3a5f',
    color: 'white',
    position: 'sticky',
    top: 0,
    zIndex: 100,
  },
  navTitle: {
    fontSize: '16px',
    fontWeight: '600',
  },
  backBtn: {
    background: 'transparent',
    border: '1px solid rgba(255,255,255,0.3)',
    color: 'white',
    padding: '6px 12px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '13px',
  },
  printBtn: {
    background: 'rgba(255,255,255,0.15)',
    border: '1px solid rgba(255,255,255,0.3)',
    color: 'white',
    padding: '6px 14px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '13px',
  },
}
